export default __webpack_public_path__ + "static/media/undraw_taking_selfie.ad2cbdc4.svg";